import { Navigate, Outlet } from 'react-router';
import { useGetCurrentUser } from '../hooks/auth.ts';

export const PrivateRoutes = () => {
  const { data: user, isPending: loading } = useGetCurrentUser();

  if (!loading) {
    return user?.userId ? <Outlet /> : <Navigate to="/" />;
  }
};
